import { FormularioTraderDadosUsuarioModel } from './FormularioTraderDadosUsuarioModel'

export class FormularioTraderModel {
    emAndamento = false
    formularios = []
    dadosUsuario = new FormularioTraderDadosUsuarioModel()
}